export default "__VITE_ASSET__BqEwUE8P__"